import { Outlet, createRootRoute } from "@tanstack/react-router";

import { QueryProviders } from "@/providers/query.provider";
import { TooltipProvider } from "@/components/ui/tooltip";

const RootLayout = () => {
  return (
    <main className="flex min-h-screen w-full">
      <QueryProviders>
        <TooltipProvider delayDuration={200}>
          <div className="flex min-h-screen w-full">
            <Outlet />
          </div>
        </TooltipProvider>
      </QueryProviders>
    </main>
  );
};

export const Route = createRootRoute({
  component: RootLayout,
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-8 text-center">
      <h1 className="text-2xl font-bold text-destructive">Something went wrong</h1>
      <pre className="mt-4 text-sm text-muted-foreground">{error.message}</pre>
    </div>
  ),
});
